<template>
	<div style="min-width: 1000px" class="max-width-control">
		<vs-popup
			:active.sync="showValidatePopup"
			title="Êtes-vous sûr de vouloir envoyer cette facture ?"
			style="min-width: 1000px"
		>
			<div
				v-if="invoiceToSend"
				class="vx-row facturation-val-box"
				style="min-width: 1000px"
			>
				<vs-table
					noDataText=""
					:max-height="tableHeight + 'px'"
					:data="displayedPendingInvoices[invoiceToSend]"
					stripe
					auto-resize
					class="w-full"
					id="invoice_table"
				>
					<template slot="thead">
						<vs-th style="width: 40px"></vs-th>
						<vs-th style="white-space: normal">N° de Contrat</vs-th>
						<vs-th style="white-space: normal">Statut du Contrat</vs-th>
						<vs-th style="white-space: normal">Société</vs-th>
						<vs-th style="white-space: normal">Commercial</vs-th>
						<vs-th style="white-space: normal">Consultant Lead</vs-th>
						<vs-th style="white-space: normal"
							>Commentaire de facturation</vs-th
						>
						<vs-th style="white-space: normal">Total Achat</vs-th>
						<vs-th style="white-space: normal">Total Facturable</vs-th>
						<vs-th style="white-space: normal"><vs-spacer />Total HT</vs-th>
						<vs-th style="white-space: normal"><vs-spacer />Total TTC</vs-th>
					</template>

					<template>
						<vs-tr :key="index" @click="togglePopupExpand()" style="cursor: pointer">
							<div v-show="false">
								{{ setRowNum(displayedPendingInvoices[invoiceToSend].length) }}
							</div>
							<vs-td style="width: 40px; text-align: center">
								<div
									@click.stop="togglePopupExpand()"
									class="expand-icon-wrapper"
									style="
										cursor: pointer !important;
										display: flex;
										justify-content: center;
										padding: 5px;
										user-select: none;
									"
								>
									<vs-icon
										:icon="
											popupExpandedRow
												? 'keyboard_arrow_down'
												: 'keyboard_arrow_right'
										"
										size="small"
										style="pointer-events: none"
									/>
								</div>
							</vs-td>
							<vs-td
								:data="displayedPendingInvoices[invoiceToSend].contract_id"
								>{{
									displayedPendingInvoices[invoiceToSend].contract_id
								}}</vs-td
							>
							<vs-td :data="displayedPendingInvoices[invoiceToSend].contract_id"
								><vs-chip
									style="width: 80px"
									:color="
										getContractStatusColor(
											displayedPendingInvoices[invoiceToSend].contract_status
										)
									"
									>{{
										getContractStatus(
											displayedPendingInvoices[invoiceToSend].contract_status
										)
									}}</vs-chip
								></vs-td
							>
							<vs-td
								:data="displayedPendingInvoices[invoiceToSend].society_name"
								>{{
									displayedPendingInvoices[invoiceToSend].society_name
								}}</vs-td
							>
							<vs-td
								:data="displayedPendingInvoices[invoiceToSend].commercial_id"
							>
								<div
									@click.stop="event.stopPropagation()"
									v-if="displayedPendingInvoices[invoiceToSend].commercial_id"
									class="vx-row center-content"
									style="margin: 0; place-content: center"
								>
									<div class="flex center">
										<vx-tooltip
											:text="
												getCollaboratorName(
													displayedPendingInvoices[invoiceToSend].commercial_id
												)
											"
											position="top"
										>
											<vs-avatar
												style="border: 1px solid"
												badge-color="rgb(140, 23, 164)"
												:text="
													getCollaboratorName(
														displayedPendingInvoices[invoiceToSend]
															.commercial_id
													)
												"
												:src="
													getCollaboratorAvatar(
														displayedPendingInvoices[invoiceToSend]
															.commercial_id
													)
												"
											/>
										</vx-tooltip>
									</div>
								</div>
							</vs-td>
							<vs-td
								:data="
									displayedPendingInvoices[invoiceToSend].account_manager_ids
								"
							>
								<div
									@click.stop="event.stopPropagation()"
									v-if="
										displayedPendingInvoices[invoiceToSend].account_manager_ids
											.length > 0
									"
									class="vx-row center-content"
									style="margin: 0; place-content: center"
								>
									<div
										v-for="(
											account_manager, amindex
										) in displayedPendingInvoices[invoiceToSend]
											.account_manager_ids"
										:key="amindex"
										class="flex center"
									>
										<vx-tooltip
											v-if="account_manager.id > 0"
											:text="getCollaboratorName(account_manager.id)"
											position="top"
										>
											<vs-avatar
												style="border: 1px solid"
												badge-color="rgb(140, 23, 164)"
												:badge="account_manager.is_lead"
												:text="getCollaboratorName(account_manager.id)"
												:src="getCollaboratorAvatar(account_manager.id)"
											/>
										</vx-tooltip>
									</div>
								</div>
							</vs-td>
							<vs-td
								:data="
									displayedPendingInvoices[invoiceToSend].invoice_commentary
								"
								>{{
									displayedPendingInvoices[invoiceToSend].invoice_commentary
								}}</vs-td
							>
							<vs-td
								:data="
									displayedPendingInvoices[invoiceToSend].total_purchase_price
								"
								class="text-right"
								>{{
									displayedPendingInvoices[invoiceToSend].total_purchase_price
										? displayedPendingInvoices[invoiceToSend]
												.total_purchase_price
										: "0"
								}}€</vs-td
							>
							<vs-td
								:data="
									displayedPendingInvoices[invoiceToSend]
										.total_purchase_sell_price
								"
								class="text-right"
								>{{
									displayedPendingInvoices[invoiceToSend]
										.total_purchase_sell_price
										? displayedPendingInvoices[invoiceToSend]
												.total_purchase_sell_price
										: "0"
								}}€</vs-td
							>
							<vs-td
								:data="displayedPendingInvoices[invoiceToSend].total_ht"
								class="text-right"
								><strong
									>{{
										displayedPendingInvoices[invoiceToSend].total_ht
									}}€</strong
								></vs-td
							>
							<vs-td
								:data="displayedPendingInvoices[invoiceToSend].total_ttc"
								class="text-right"
								><strong
									>{{
										displayedPendingInvoices[invoiceToSend].total_ttc
									}}€</strong
								></vs-td
							>
						</vs-tr>
						<tr
							v-if="popupExpandedRow"
							:key="'popup-expand'"
							class="expand-row"
						>
							<td colspan="11" style="padding: 0">
								<div style="width: 100%; display: flex">
									<vs-table
										:data="
											displayedPendingInvoices[invoiceToSend].items.filter(
												(row) => row.to_bill == 1
											)
										"
										stripe
										:max-items="15"
										class="w-full"
									>
										<template slot="thead">
											<vs-th class="text-left">Prestation</vs-th>
											<vs-th class="text-center">Prix Unitaire</vs-th>
											<vs-th class="text-center">Quantité</vs-th>
											<vs-th class="text-center">Total HT</vs-th>
											<vs-th>% TVA</vs-th>
											<vs-th class="text-center">Description</vs-th>
										</template>

										<template slot-scope="{ data }">
											<vs-tr
												:data="item"
												:key="itemIndex"
												v-for="(item, itemIndex) in data"
											>
												<vs-td class="text-left">{{ item.name }}</vs-td>
												<vs-td class="text-left">{{ item.price }}€</vs-td>
												<vs-td class="text-left">{{ item.quantity }}</vs-td>
												<vs-td class="text-left">{{ item.total_price }}€</vs-td>
												<vs-td class="text-left"
													>{{ getTVA(item.tva_id) }}%</vs-td
												>
												<vs-td class="text-left">{{ item.commentary }}</vs-td>
											</vs-tr>
										</template>
									</vs-table>
								</div>
							</td>
						</tr>
					</template>
				</vs-table>
				<div class="vx-col sm:w-1/2">
					<vs-button
						class="mt-2 w-full"
						:disabled="acceptBillingLoad"
						@click="acceptBilling()"
						>Oui</vs-button
					>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="declineBilling()"
						>Non</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<vs-table
			noDataText="Aucune facture à éditer"
			:data="displayedPendingInvoices"
			:max-height="tableHeight + 'px'"
			class="w-full"
		>
			<template slot="thead">
				<vs-th class="th-sticky" style="width: 40px; pointer-events: auto">
					<div
						@click.stop="toggleAllExpand()"
						class="expand-icon-wrapper"
						style="
							cursor: pointer !important;
							display: flex;
							justify-content: center;
							pointer-events: auto;
							padding: 5px;
							user-select: none;
						"
						:style="{
							transform: allExpanded ? 'rotate(0deg)' : 'rotate(0deg)',
						}"
					>
						<vs-icon
							:icon="
								allExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
							"
							size="small"
							style="pointer-events: none"
						/>
					</div>
				</vs-th>
				<vs-th class="th-sticky" style="white-space: normal">N° Contrat</vs-th>
				<vs-th class="th-sticky" style="white-space: normal">Statut</vs-th>
				<vs-th class="th-sticky" style="white-space: normal">Date</vs-th>
				<vs-th class="th-sticky" style="white-space: normal">Société</vs-th>
				<vs-th class="th-sticky" style="white-space: normal">Commercial</vs-th>
				<vs-th class="th-sticky" style="white-space: normal"
					>Consultant Lead</vs-th
				>
				<vs-th class="th-sticky" style="white-space: normal">Commentaire</vs-th>
				<vs-th class="th-sticky" style="white-space: normal"
					>Achat / Facturable</vs-th
				>
				<vs-th class="th-sticky"
					><span class="w-full text-center" style="white-space: normal"
						>Achats hors-période</span
					></vs-th
				>
				<vs-th class="th-sticky"><vs-spacer />HT</vs-th>
				<vs-th class="th-sticky"><vs-spacer />TTC</vs-th>
				<vs-th class="th-sticky" style="width: 90px">Ads </vs-th>
				<!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
				<vs-th class="th-sticky"></vs-th>
				<vs-th class="th-sticky"></vs-th>
			</template>

			<template slot-scope="{ data }" :data="displayedPendingInvoices">
				<tbody v-for="(pending_invoice, index) in data" :key="'row-' + index">
					<vs-tr
						ref="switch"
						@click="toggleExpandIfNotInteractive($event, index)"
						style="cursor: pointer"
					>
						<vs-td style="width: 40px; text-align: center">
							<div
								@click.stop="toggleExpand(index)"
								class="expand-icon-wrapper"
								style="
									cursor: pointer !important;
									display: flex;
									justify-content: center;
									padding: 5px;
									user-select: none;
								"
								:style="{
									transform: expandedRows[index]
										? 'rotate(0deg)'
										: 'rotate(0deg)',
								}"
							>
								<vs-icon
									:icon="
										expandedRows[index]
											? 'keyboard_arrow_down'
											: 'keyboard_arrow_right'
									"
									size="small"
									style="pointer-events: none"
								/>
							</div>
						</vs-td>
						<vs-td :data="pending_invoice.contract_id"
							><span @click.stop="event.stopPropagation()"
								><span
									@click="displayContractPopup(pending_invoice.contract_id)"
									class="hvr-underline hvr-underline-out"
									>{{ pending_invoice.contract_id }}</span
								></span
							></vs-td
						>
						<vs-td :data="pending_invoice.contract_status">
							<div @click.stop="event.stopPropagation()">
								<vs-chip
									style="width: 80px"
									:color="
										getContractStatusColor(pending_invoice.contract_status)
									"
									>{{ getContractStatus(pending_invoice.contract_status) }}
								</vs-chip>
							</div>
						</vs-td>
						<vs-td
							:data="pending_invoice.invoice_date"
							class="text-center pdl0"
							>{{ toFrenchDate(pending_invoice.invoice_date) }}</vs-td
						>
						<vs-td :data="pending_invoice.society_name"
							><span @click.stop="event.stopPropagation()"
								><span
									@click="displaySocietyPopup(pending_invoice.society_id)"
									class="hvr-underline hvr-underline-out"
									>{{ pending_invoice.society_name }}</span
								></span
							></vs-td
						>
						<vs-td
							:data="pending_invoice.commercial_id"
							class="text-center pdl0"
						>
							<div @click.stop="event.stopPropagation()">
								<avatar-message-chip
									:key="index"
									:user="{
										users_id: pending_invoice.commercial_id,
										name: getCollaboratorName(pending_invoice.commercial_id),
										is_lead: false,
									}"
									:contract="{
										id: pending_invoice.contract_id,
										society_id: pending_invoice.society_id,
									}"
								/>
							</div>
						</vs-td>
						<vs-td :data="pending_invoice.account_manager_ids" class="pdl0">
							<div
								@click.stop="event.stopPropagation()"
								v-if="pending_invoice.account_manager_ids.length > 0"
								class="vx-row center-content"
								style="margin: 0; place-content: center"
							>
								<div
									v-for="(
										account_manager, amindex
									) in pending_invoice.account_manager_ids"
									:key="amindex"
									class="flex center"
								>
									<div @click.stop="event.stopPropagation()">
										<avatar-message-chip
											:key="index"
											:user="{
												users_id: account_manager.id,
												name: getCollaboratorName(account_manager.id),
												is_lead: false,
											}"
											:contract="{
												id: pending_invoice.contract_id,
												society_id: pending_invoice.society_id,
											}"
										/>
									</div>
								</div>
							</div>
						</vs-td>
						<vs-td :data="pending_invoice.invoice_commentary">{{
							pending_invoice.invoice_commentary
						}}</vs-td>
						<vs-td
							:data="pending_invoice.total_purchase_price"
							class="text-right"
							style="padding-right: 12px"
							>{{
								pending_invoice.total_purchase_price
									? pending_invoice.total_purchase_price
									: "0"
							}}€ /
							<span
								v-if="pending_invoice.total_purchase_sell_price > 0"
								style="font-weight: bold; color: #08b0b9"
								>{{ pending_invoice.total_purchase_sell_price }}€</span
							>
							<span v-else style="color: grey">0€</span></vs-td
						>
						<vs-td
							:data="pending_invoice.total_purchase_price"
							class="text-right"
							@click.stop="event.stopPropagation()"
						>
							<vs-button
								@click="displayPurchasesPopup(pending_invoice)"
								v-if="pending_invoice.unexpected_purchases.length > 0"
								><span
									style="border-radius: 5px; color: white"
									class="px-2 ml-1"
									>{{
										getTotalUnexpectedPurchase(
											pending_invoice.unexpected_purchases
										)
									}}</span
								></vs-button
							>
						</vs-td>
						<vs-td
							:data="pending_invoice.total_ht"
							class="text-right"
							style="padding-right: 13px"
							><strong
								>{{ parseFloat(pending_invoice.total_ht.toFixed(2)) }}€</strong
							></vs-td
						>
						<vs-td
							:data="pending_invoice.total_ttc"
							class="text-right"
							style="padding-right: 13px"
							><strong
								>{{ parseFloat(pending_invoice.total_ttc.toFixed(2)) }}€</strong
							></vs-td
						>
						<vs-td
							:data="pending_invoice.google_ads_mcc"
							class="text-right"
							style="padding-right: 13px"
							:key="`${googleAdsKey}-${pending_invoice.society_id}`"
						>
							<div v-if="pending_invoice.contract_type == 2">
								<!-- Show individual loading state for each society -->
								<div
									v-if="isGoogleAdsLoading(pending_invoice.society_id)"
									class="text-right"
									style="padding-right: 13px"
								>
									<circular-loader />
								</div>
								<!-- Show the component when this specific society's data is loaded -->
								<google-ads-cost-view-chip
									v-else
									:type_id="pending_invoice.contract_type"
									:google_ads_mcc="pending_invoice.google_ads_mcc"
									:googleAds="
										getGoogleAdsForSociety(pending_invoice.society_id)
									"
									:societyId="pending_invoice.society_id"
									:date="pending_invoice.invoice_date"
								/>
							</div>
						</vs-td>

						<vs-td class="text-center"
							><span @click.stop="event.stopPropagation()"
								><vs-button
									@click="acceptInvoice(String(index))"
									:color="isBilled(index)"
									style="height: 50px"
									>{{
										pending_invoice.is_sent == 1 ? "Facturé" : "Facturer"
									}}</vs-button
								></span
							></vs-td
						>
						<vs-td class="text-center"
							><span @click.stop="event.stopPropagation()"
								><vs-button
									v-if="pending_invoice.is_sent != 1"
									@click="cancelInvoice(index)"
									:color="isNotBilled(index)"
									style="height: 50px"
									>{{
										pending_invoice.is_sent == 2
											? "Non Facturé"
											: "Ne pas facturer"
									}}</vs-button
								></span
							></vs-td
						>
					</vs-tr>
					<tr
						v-if="expandedRows[index]"
						:key="'expand-' + index"
						class="expand-row"
					>
						<td :colspan="16" style="padding: 0">
							<div class="w-full mx-0">
								<div class="vx-row w-full" style="width: 100%; display: flex">
									<!-- Only invoices with no orders -->
									<vs-table
										:key="pendingItemsRefreshKey"
										:data="pending_invoice.items"
										stripe
										:max-items="15"
										class="w-full"
									>
										<template slot="thead">
											<vs-th></vs-th>
											<vs-th class="pdl0" style="white-space: normal"
												>Prestation</vs-th
											>

											<vs-th
												><span
													class="w-full text-right"
													style="white-space: normal"
													>Consultant</span
												></vs-th
											>
											<vs-th
												><span
													class="w-full text-right"
													style="white-space: normal"
													>Prix Unitaire HT</span
												></vs-th
											>
											<vs-th class="text-right" style="white-space: normal"
												><vs-spacer />Quantité</vs-th
											>
											<vs-th
												><span
													class="w-full text-right"
													style="white-space: normal"
													>HT</span
												></vs-th
											>
											<vs-th class="text-right" style="white-space: normal"
												><vs-spacer />% TVA</vs-th
											>
											<vs-th
												><span
													class="w-full text-right"
													style="white-space: normal"
													>TTC</span
												></vs-th
											>
											<vs-th class="pdl0" style="white-space: normal"
												>Description</vs-th
											>
											<vs-th class="pdl0" style="white-space: normal"
												>Brief</vs-th
											>
											<vs-th class="pdl0" style="white-space: normal"
												>Commentaires Periode</vs-th
											>
											<vs-th class="pdl0" style="white-space: normal"
												>Prix Collab.</vs-th
											>
											<vs-th></vs-th>
										</template>

										<template slot-scope="{ data }">
											<vs-tr
												:data="item"
												:key="itemIndex"
												v-for="(item, itemIndex) in data.filter(
													(ele) => ele.is_order == 0
												)"
											>
												<vs-td class="text-left" style="width: 20px"
													><vs-checkbox
														v-model="item.to_bill"
														@change="updateHTPrices(index)"
												/></vs-td>
												<vs-td class="text-left" style="width: 120px">{{
													item.name
												}}</vs-td>
												<vs-td
													v-if="!item.edit_state"
													:data="item.manager_id"
													class="pdl0"
												>
													<div
														@click.stop="event.stopPropagation()"
														class="vx-row center-content"
														style="margin: 0; place-content: center"
													>
														<div class="flex center">
															<avatar-message-chip
																:key="index"
																:user="{
																	users_id: item.manager_id,
																	name: getCollaboratorName(item.manager_id),
																	is_lead: false,
																}"
																:contract="{
																	id: pending_invoice.contract_id,
																	society_id: pending_invoice.society_id,
																}"
															/>
														</div>
													</div>
												</vs-td>

												<vs-td v-else :data="item.manager_id" class="pdl0">
													<div
														@click.stop="event.stopPropagation()"
														class="vx-row center-content"
														style="margin: 0; place-content: center"
													>
														<div class="flex center">
															<vs-select
																autocomplete
																v-model="item.manager_id"
																class="select-large mt-4"
																placeholder="Consultant"
																label="Consultant"
															>
																<vs-select-item
																	:key="index"
																	:value="item.id"
																	:text="item.firstname + ' ' + item.lastname"
																	v-for="(item, index) in allConsultantList"
																	class="w-full"
																/>
															</vs-select>
														</div>
													</div>
												</vs-td>

												<vs-td
													class="text-right"
													style="padding-right: 12px; width: 80px"
													v-if="item.edit_state"
												>
													<vs-input
														v-model="item.price"
														style="width: 80px"
														@input="updateItemPrice(index, itemIndex)"
														class="mr-2"
													/>
												</vs-td>
												<vs-td
													class="text-right"
													style="padding-right: 12px"
													v-else
													>{{ item.price + "€" }}</vs-td
												>
												<vs-td
													class="text-right w-20"
													style="padding-right: 12px; width: 80px"
													v-if="item.edit_state"
												>
													<vs-input
														v-model="item.quantity"
														style="width: 50px"
														@input="updateItemPrice(index, itemIndex)"
														class="mr-2"
													/>
												</vs-td>
												<vs-td
													class="text-right"
													style="padding-right: 12px"
													v-else
													>{{ item.quantity }}</vs-td
												>
												<vs-td class="text-right" style="padding-right: 12px">{{
													item.total_price +
													"€" +
													(item.sold_percentage
														? "+" + item.sold_percentage + "%"
														: "")
												}}</vs-td>
												<vs-td
													class="text-right w-20"
													style="padding-right: 12px; width: 80px"
													v-if="item.edit_state"
												>
													<vs-select
														v-model="item.tva_id"
														class="w-full select-medium mr-2"
														label="% TVA"
														@change="updateItemPrice(index, itemIndex)"
													>
														<vs-select-item
															:key="index"
															:value="row.id"
															:text="row.name"
															v-for="(row, index) in tvaList"
															class="w-full"
														/>
													</vs-select>
												</vs-td>
												<vs-td
													class="text-right"
													style="padding-right: 12px"
													v-else
													>{{ item.tva_percentage }}%</vs-td
												>
												<vs-td class="text-right" style="padding-right: 12px"
													>{{ item.ttc_total_price }}€</vs-td
												>
												<vs-td
													class="text-left"
													v-if="item.edit_state"
													style="width: 400px"
													><vs-input
														style="width: 400px"
														v-model="item.commentary"
														label="Description"
												/></vs-td>
												<vs-td class="text-left" v-else>{{
													item.commentary
												}}</vs-td>
												<vs-td class="text-center" style="width: 40px">
													<div v-if="item.comment_mission">
														<vx-tooltip
															:text="item.comment_mission"
															class="cursor-pointer"
														>
															<span
																class="material-symbols-outlined"
																style="color: #626262"
																>message</span
															>
														</vx-tooltip>
													</div></vs-td
												>
												<vs-td class="text-center" style="width: 40px">
													<div v-if="item.task_comment_facturation">
														<vx-tooltip
															:text="item.task_comment_facturation"
															class="cursor-pointer"
														>
															<span
																class="material-symbols-outlined"
																style="color: #626262"
																>message</span
															>
														</vx-tooltip>
													</div></vs-td
												>
												<vs-td class="text-left">{{
													item.prix_collab_text
														? item.prix_collab_text + "€"
														: ""
												}}</vs-td>
												<vs-td class="text-left" :data="item">
													<vs-button
														v-if="!item.edit_state"
														@click="item.edit_state = true"
														>Modifier</vs-button
													>
													<vs-button v-else @click="updateItem(item)"
														>Verrouiller</vs-button
													>
												</vs-td>
											</vs-tr>
										</template>
									</vs-table>
								</div>
								<div class="vx-row w-full" style="width: 100%; display: flex">
									<!-- Only invoices with  orders -->
									<vs-table
										:data="
											pending_invoice.items.filter((row) => row.is_order == 1)
										"
										stripe
										:max-items="15"
										class="w-full"
									>
										<template slot="thead">
											<vs-th></vs-th>
											<vs-th class="pdl0" style="white-space: normal"
												>Commande</vs-th
											>

											<vs-th
												><span
													class="w-full text-right"
													style="white-space: normal"
													>Consultant</span
												></vs-th
											>
											<vs-th
												><span
													class="w-full text-right"
													style="white-space: normal"
													>Prix Unitaire HT</span
												></vs-th
											>
											<vs-th class="text-right" style="white-space: normal"
												><vs-spacer />Quantité</vs-th
											>
											<vs-th
												><span
													class="w-full text-right"
													style="white-space: normal"
													>HT</span
												></vs-th
											>
											<vs-th class="text-right" style="white-space: normal"
												><vs-spacer />% TVA</vs-th
											>
											<vs-th
												><span
													class="w-full text-right"
													style="white-space: normal"
													>TTC</span
												></vs-th
											>
											<vs-th class="pdl0" style="white-space: normal"
												>Description</vs-th
											>
											<vs-th class="pdl0" style="white-space: normal"
												>Prix Collab.</vs-th
											>
											<vs-th></vs-th>
										</template>

										<template slot-scope="{ data }">
											<vs-tr
												:data="item"
												:key="itemIndex"
												v-for="(item, itemIndex) in data"
											>
												<vs-td class="text-left" style="width: 20px"
													><vs-checkbox
														v-model="item.to_bill"
														@change="updateHTPrices(index)"
												/></vs-td>
												<vs-td class="text-left" style="width: 120px">{{
													item.name
												}}</vs-td>
												<vs-td
													v-if="!item.edit_state"
													:data="item.manager_id"
													class="pdl0"
												>
													<div
														@click.stop="event.stopPropagation()"
														class="vx-row center-content"
														style="margin: 0; place-content: center"
													>
														<div class="flex center">
															<vx-tooltip
																:text="getCollaboratorName(item.manager_id)"
																position="top"
															>
																<vs-avatar
																	style="border: 1px solid"
																	badge-color="rgb(140, 23, 164)"
																	:text="getCollaboratorName(item.manager_id)"
																	:src="getCollaboratorAvatar(item.manager_id)"
																/>
															</vx-tooltip>
														</div>
													</div>
												</vs-td>

												<vs-td v-else :data="item.manager_id" class="pdl0">
													<div
														@click.stop="event.stopPropagation()"
														class="vx-row center-content"
														style="margin: 0; place-content: center"
													>
														<div class="flex center">
															<vs-select
																autocomplete
																v-model="item.manager_id"
																class="select-large mt-4"
																placeholder="Consultant"
																label="Consultant"
															>
																<vs-select-item
																	:key="index"
																	:value="item.id"
																	:text="item.firstname + ' ' + item.lastname"
																	v-for="(item, index) in allConsultantList"
																	class="w-full"
																/>
															</vs-select>
														</div>
													</div>
												</vs-td>

												<vs-td
													class="text-right"
													style="padding-right: 12px; width: 80px"
													v-if="item.edit_state"
												>
													<vs-input
														v-model="item.price"
														style="width: 80px"
														@input="updateItemPrice(index, itemIndex)"
														class="mr-2"
													/>
												</vs-td>
												<vs-td
													class="text-right"
													style="padding-right: 12px"
													v-else
													>{{ item.price + "€" }}</vs-td
												>
												<vs-td
													class="text-right w-20"
													style="padding-right: 12px; width: 80px"
													v-if="item.edit_state"
												>
													<vs-input
														v-model="item.quantity"
														style="width: 50px"
														@input="updateItemPrice(index, itemIndex)"
														class="mr-2"
													/>
												</vs-td>
												<vs-td
													class="text-right"
													style="padding-right: 12px"
													v-else
													>{{ item.quantity }}</vs-td
												>
												<vs-td class="text-right" style="padding-right: 12px">{{
													item.total_price +
													"€" +
													(item.sold_percentage
														? "+" + item.sold_percentage + "%"
														: "")
												}}</vs-td>
												<vs-td
													class="text-right w-20"
													style="padding-right: 12px; width: 80px"
													v-if="item.edit_state"
												>
													<vs-select
														v-model="item.tva_id"
														class="w-full select-medium mr-2"
														label="% TVA"
														@change="updateItemPrice(index, itemIndex)"
													>
														<vs-select-item
															:key="index"
															:value="row.id"
															:text="row.name"
															v-for="(row, index) in tvaList"
															class="w-full"
														/>
													</vs-select>
												</vs-td>
												<vs-td
													class="text-right"
													style="padding-right: 12px"
													v-else
													>{{ item.tva_percentage }}%</vs-td
												>
												<vs-td class="text-right" style="padding-right: 12px"
													>{{ item.ttc_total_price }}€</vs-td
												>
												<vs-td
													class="text-left"
													v-if="item.edit_state"
													style="width: 400px"
													><vs-input
														style="width: 400px"
														v-model="item.commentary"
														label="Description"
												/></vs-td>
												<vs-td class="text-left" v-else>{{
													item.commentary
												}}</vs-td>
												<vs-td class="text-left">{{
													item.prix_collab_text
														? item.prix_collab_text + "€"
														: ""
												}}</vs-td>
												<vs-td class="text-left" :data="item">
													<vs-button
														v-if="!item.edit_state"
														@click="item.edit_state = true"
														>Modifier</vs-button
													>
													<vs-button v-else @click="updateItem(item)"
														>Verrouiller</vs-button
													>
												</vs-td>
											</vs-tr>
										</template>
									</vs-table>
								</div>
								<div class="vx-row w-full">
									<div class="vx-col ml-5">
										<NewInvoiceItemWidget
											class="releaseClick w-full"
											style="max-width: none !important"
											:index="index"
											:tva_id="pending_invoice.tva_type_id"
											:leadId="pending_invoice.account_manager_ids[0].id"
											:pending_invoice_id="pending_invoice.id"
											:missionsCategories="
												missionsByCategory[pending_invoice.contract_type]
											"
											@add-item="addItem($event)"
										/>
									</div>
									<div class="vx-col ml-5 mt-5">
										<InvoiceFacturationTable
											class="releaseClick"
											:pending_invoice="pending_invoice"
											@export-invoice="addInvoiceTemporaryItems(index, $event)"
											@export-invoice-item="
												addInvoiceTemporaryOneItem(index, $event)
											"
										/>
									</div>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</template>
		</vs-table>
	</div>
</template>
  
<script>
import $ from "jquery";
import Vue from "vue";
import store from "@/store/store";
import utilsMixin from "@/mixins/utilsMixin.js";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import NotepadPopup from "@/components/popups/NotepadPopup.vue";
import InvoiceFacturationTable from "@/components/widgets/InvoiceFacturationTable";
import NewInvoiceItemWidget from "@/components/widgets/NewInvoiceItemWidget";

import PurchasesViewerPopup from "@/components/popups/PurchasesViewerPopup";
import AvatarMessageChip from "../chips/AvatarMessageChip.vue";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import GoogleAdsCostViewChip from "../chips/GoogleAdsCostViewChip.vue";
import Society from "../../entities/Society";
import CircularLoader from "../widgets/loader/CircularLoader.vue";

export default {
	name: "InvoicesTable",
	props: {
		pending_invoices: Array,
		apiUrl: String,
	},
	mixins: [utilsMixin, dbFieldConvertorMixin],
	components: {
		flatPickr,
		InvoiceFacturationTable,
		NewInvoiceItemWidget,
		PurchasesViewerPopup,
		AvatarMessageChip,
		GoogleAdsCostViewChip,
		CircularLoader,
	},
	data() {
		return {
			apiErrorMsg: null, // catching api error message
			invoiceToSend: null,
			newItems: [],
			invoicesItems: [],
			displayedPendingInvoices: [],
			historicalInvoices: [],
			expandedRows: {},
			allExpanded: false,
			popupExpandedRow: true,
			invoiceRefreshKey: 0,
			providerPurchasesDetail: [],
			missionsByCategory: {},
			selectedContract: null,
			selectedSociety: null,
			contractsSocietiesWithName: null,
			//FILTERS
			providerFilter: null,
			recurrenceFilter: null,
			acceptBillingLoad: false,
			dateFromFilter: null,
			dateToFilter: null,
			configDatePicker: {
				dateFormat: "d/m/Y",
			},
			showNotepadPopup: false,
			selectAll: false,
			showValidatePopup: false,
			showDatePopup: false,
			showPurchasesPopup: false,
			currentPurchase: null,
			currentPurchases: [],
			currentPurchaseInvoiceDateTemp: null,
			tmpValidateList: [],
			tmpNum: "",
			tmpNumber: "",
			tvaList: [],
			pendingItemsRefreshKey: 0,
			//  Google Ads - Updated properties for individual fetching
			googleAdsData: {}, // Object to store ads data by society_id
			googleAdsLoadingStates: {}, // Track loading state per society
			googleAdsKey: 0,
		};
	},
	beforeUnmount() {
		// Find and remove any lingering tooltip elements
		const tooltips = document.querySelectorAll(".vx-tooltip-content");
		tooltips.forEach((tooltip) => tooltip.remove());
	},
	created() {
		// console.log("InvoicesTable created");
		// debugger;
		store.dispatch("getAllCollaboratorsAvatar");
		store.dispatch("getAllMissions");
		store.dispatch("getAllProviders");
		store.dispatch("getAllServices");
		store.dispatch("getAllSocieties");
		this.getAllProductsCategories();
		this.getAllProducts();
		this.displayPendingInvoices();
		this.getAllMissionsByCategories();
		this.getAllTVA();
		this.fetchGoogleAds();
	},

	mounted() {
		store.dispatch(
			"updateTableHeight",
			this.windowHeigth -
				this.horizentalNavBarHeight -
				this.filterCardHeight -
				0.12 * this.windowHeigth
		);
		this.$nextTick(() => {
			window.addEventListener("resize", () => {
				store.dispatch(
					"updateTableHeight",
					this.windowHeigth -
						this.horizentalNavBarHeight -
						this.filterCardHeight -
						0.12 * this.windowHeigth
				);
			});
		});
		// Custom expand functionality is now handled via Vue methods
	},
	computed: {
		filterCardHeight: () => {
			return store.state.filterCardHeight;
		},
		isFilterDown: () => {
			return store.state.isFilterDown;
		},
		horizentalNavBarHeight: () => {
			return store.state.horizentalNavBarHeight;
		},
		windowHeigth: () => {
			return store.state.windowHeigth;
		},
		tableHeight: () => {
			return store.state.tableHeight;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
		missions: () => {
			return store.state.missions;
		},
		societies: () => {
			return store.state.societies;
		},
		products: () => {
			return store.state.products;
		},
		products_categories: () => {
			return store.state.products_categories;
		},
		providers: () => {
			return store.state.providers;
		},
		services: () => {
			return store.state.services;
		},
		allConsultantList: () => {
			return store.state.collaborators.filter((collaborator) =>
				[9, 6, 3, 7].includes(collaborator.type)
			);
		},
	},
	updated() {
		// console.log("InvoicesTable updated");
		// debugger;
		store.dispatch(
			"updateTableHeight",
			this.windowHeigth -
				this.horizentalNavBarHeight -
				this.filterCardHeight -
				0.12 * this.windowHeigth
		);
	},
	watch: {
		displayedPendingInvoices: function (data) {
			this.setRowNum(data.length);
		},
		showValidatePopup: function (data) {
			if (data) {
				// Auto-expand the validation popup rows
				// No longer needed with custom expand functionality
			}
		},
		isFilterDown: function () {
			store.dispatch(
				"updateFilterCardHeight",
				document.getElementById("fliterCard").clientHeight
			);
			store.dispatch(
				"updateTableHeight",
				this.windowHeigth -
					this.horizentalNavBarHeight -
					this.filterCardHeight -
					0.12 * this.windowHeigth
			);
		},
		"$props.pending_invoices": function (data) {
			if (data.length == 0) {
				this.setRowNum(0);
			}
			// this.displayPendingInvoices();
		},
		invoiceRefreshKey: function () {
			// //console.log(this.invoiceRefreshKey);
		},
		products: function () {
			this.getAllMissionsByCategories();
		},
		products_categories: function () {
			this.getAllMissionsByCategories();
		},
	},

	methods: {
		toggleExpand(index) {
			this.$set(this.expandedRows, index, !this.expandedRows[index]);
		},
		toggleAllExpand() {
			this.allExpanded = !this.allExpanded;
			const newExpandedRows = {};
			if (this.allExpanded) {
				// Expand all rows
				for (let i = 0; i < this.displayedPendingInvoices.length; i++) {
					newExpandedRows[i] = true;
				}
			}
			// If collapsing all, newExpandedRows remains empty
			this.expandedRows = newExpandedRows;
		},
		toggleExpandIfNotInteractive(event, index) {
			// Check if the clicked element or its parents are interactive elements
			const interactiveElements = [
				"BUTTON",
				"INPUT",
				"SELECT",
				"TEXTAREA",
				"A",
				"VS-BUTTON",
				"VS-CHECKBOX",
			];
			let element = event.target;

			// Walk up the DOM tree to check for interactive elements
			while (element && element !== event.currentTarget) {
				if (interactiveElements.includes(element.tagName)) {
					return; // Don't expand if clicking on an interactive element
				}
				// Check for click handlers that stop propagation
				if (element.onclick || element.getAttribute("@click")) {
					return;
				}
				// Check for specific class names that indicate interactive elements
				if (
					element.classList &&
					(element.classList.contains("hvr-underline") ||
						element.classList.contains("vs-checkbox"))
				) {
					return;
				}
				element = element.parentElement;
			}

			// If we got here, it's safe to toggle expand
			this.toggleExpand(index);
		},
		togglePopupExpand() {
			this.popupExpandedRow = !this.popupExpandedRow;
		},
		displayNotePadPopup(contract) {
			//Initialisation des données pour le popup
			this.showNotepadPopup = true;
			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(NotepadPopup);
			let notepadPopup = new ComponentClass({
				propsData: {
					contract_id: contract.contract_id,
					popupActive: this.showNotepadPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
					society_id: contract.society_id,
					selectedCommercial: contract.commercial_id,
				},
			});
			notepadPopup.$mount();
			this.$refs.popupContainer.appendChild(notepadPopup.$el);
			notepadPopup.$on("close-popup", (data) => {
				this.showNotepadPopup = false;
			});
		},
		getTotalUnexpectedPurchase(data) {
			const totalPrice = data.reduce((sum, item) => sum + item.price, 0);
			return this.convertInternationalNumberToFrenchCurrency(totalPrice);
		},
		setRowNum(len) {
			store.dispatch("setRowNum", len);
		},

		ifMissionComing(invoice, item) {
			if (this.missions) {
				let foundMission = this.missions.filter(
					(m) =>
						m.contract_id == invoice.contract_id &&
						m.id == item.mission_id &&
						m.status == 8
				);
				if (foundMission.length > 0) return true;
				else return false;
			} else return false;
		},
		displayPurchasesPopup(contract) {
			this.showPurchasesPopup = true;
			let ComponentClass = Vue.extend(PurchasesViewerPopup);
			let purchasesPopup = new ComponentClass({
				propsData: {
					popupActive: this.showPurchasesPopup,
					apiUrl: this.apiUrl,
					contractId: contract.contract_id,
					societyName: contract.society_name,
					allCollaboratorsAvatar: this.allCollaboratorsAvatar,
					services: this.services,
					societies: this.societies,
					providers: this.providers,
					list: contract.unexpected_purchases,
				},
			});

			purchasesPopup.$mount();
			this.$refs.popupContainer.appendChild(purchasesPopup.$el);
		},

		toFrenchDate(invoice_date) {
			try {
				return moment(invoice_date).format("DD/MM/YYYY");
			} catch (err) {
				return "";
			}
		},

		getAllMissionsByCategories() {
			this.missionsByCategory = {};
			let otherProductIndex = this.products.findIndex(
				(row) =>
					row.category == 7 && row.sub_category == 11 && row.perform == "Divers"
			);

			let otherProduct = null;
			if (otherProductIndex >= 0)
				otherProduct = this.products[otherProductIndex];
			for (let i = 0; i < this.products_categories.length; i++) {
				this.missionsByCategory[String(this.products_categories[i].id)] = [];
				let tmp = this.products.filter(
					(row) => row.category == this.products_categories[i].id
				);
				let ortherCategories = this.products.filter(
					(row) => row.category != this.products_categories[i].id
				);

				tmp.sort(function (a, b) {
					var textA = a.perform.toUpperCase();
					var textB = b.perform.toUpperCase();
					return textA < textB ? -1 : textA > textB ? 1 : 0;
				});
				ortherCategories.sort(function (a, b) {
					var textA = a.perform.toUpperCase();
					var textB = b.perform.toUpperCase();
					return textA < textB ? -1 : textA > textB ? 1 : 0;
				});

				this.missionsByCategory[String(this.products_categories[i].id)].push([
					...tmp,
					...ortherCategories,
				]);
				this.missionsByCategory[String(this.products_categories[i].id)].push(
					this.products_categories[i].id
				);

				if (otherProduct)
					this.missionsByCategory[
						String(this.products_categories[i].id)
					][0].unshift(otherProduct);
			}
		},
		addItem(newItem) {
			// "/invoices/item/new"
			let foundProduct = this.products.findIndex(
				(row) => row.id == newItem.product_id
			);
			let product_name = "";
			if (foundProduct >= 0) {
				product_name = this.products[foundProduct].perform;
			}
			let params = {
				product_id: newItem.product_id,
				name: product_name,
				commentary: newItem.commentary,
				mission_id: null, // SET THIS NULLABLE IN DB
				pending_invoice_id: newItem.pending_invoice_id,
				to_bill: true,
				quantity: newItem.quantity,
				price: newItem.price,
				tva_id: newItem.tva_id,
				manager_id: newItem.manager_id,
				sold_percentage: 0,
				prix_collab_text: null,
				is_order: 0,
			};
			this.$http
				.post(this.apiUrl + "pending_invoices/invoices/item/new", params)
				.then((result) => {
					let foundTVA = this.tvaList.findIndex(
						(row) => row.id == result.data.tva_id
					);
					let tva_percentage = 0;
					let ttc_total_price = 0;
					if (foundTVA >= 0) {
						tva_percentage = this.tvaList[foundTVA].percentage;
						ttc_total_price =
							result.data.quantity *
							result.data.price *
							(1 + tva_percentage / 100);
					}
					let formatedData = {
						id: result.data.id,
						mission_id: result.data.mission_id,
						product_id: result.data.product_id,
						name: result.data.name,
						commentary: result.data.commentary,
						to_bill: result.data.to_bill,
						price: result.data.price,
						quantity: result.data.quantity,
						total_price: result.data.quantity * result.data.price,
						tva_id: result.data.tva_id,
						tva_percentage: tva_percentage,
						ttc_total_price: ttc_total_price,
						manager_id: newItem.manager_id,
						edit_state: false,
						sold_percentage: 0,
						prix_collab_text: null,
						is_order: 0,
					};
					this.displayedPendingInvoices[newItem.index].items.push(formatedData);
					this.pendingItemsRefreshKey++;
				})
				.catch((err) => {
					console.log("Error addItem:", err);
				});
		},

		addInvoiceTemporaryItems(index, invoice) {
			this.$http
				.get(this.apiUrl + "pending_invoices/products/all/")
				.then((result) => {
					let qbProducts = result.data;
					for (let i = 0; i < invoice.line_items.length; i++) {
						let qbProduct = qbProducts.find(
							(product) =>
								product.quickbooks_item_id == invoice.line_items[i].product_id
						);
						if (qbProduct) {
							let formatedData = {
								id: null,
								mission_id: null,
								product_id: qbProduct.product_id,
								name: invoice.line_items[i].label,
								manager_id: this.displayedPendingInvoices[index]
									.account_manager_ids[0]["id"]
									? Number(
											this.displayedPendingInvoices[index]
												.account_manager_ids[0]["id"]
									  )
									: null,
								commentary: invoice.line_items[i].description,
								to_bill: 0,
								price: Number(invoice.line_items[i].currency_price_before_tax),
								quantity: Number(invoice.line_items[i].quantity),
								total_price: Number(invoice.line_items[i].currency_amount),
								tva_id: this.displayedPendingInvoices[index].tva_type_id,
								tva_name: this.displayedPendingInvoices[index].tva_name,
								tva_percentage:
									this.displayedPendingInvoices[index].tva_percentage,
								edit_state: false,
								sold_percentage: 0,
								prix_collab_text: null,
								is_order: 0,
							};
							this.displayedPendingInvoices[index].items.push(formatedData);
							this.updateItemPrice(
								index,
								this.displayedPendingInvoices[index].items.length - 1
							);
							this.pendingItemsRefreshKey++;
						}
					}
				})
				.catch((err) => {
					console.log("Error addInvoiceTemporaryItems", err);
				});
		},
		addInvoiceTemporaryOneItem(index, invoice) {
			console.log("Invoices", index, invoice);
			this.$http
				.get(this.apiUrl + "pending_invoices/products/all/")
				.then((result) => {
					let qbProducts = result.data;
					let qbProduct = qbProducts.find(
						(product) => product.quickbooks_item_id == invoice.product_id
					);
					let formatedData = {
						id: null,
						mission_id: null,
						product_id: qbProduct ? qbProduct.product_id : null,
						name: invoice.label,
						manager_id: this.displayedPendingInvoices[index]
							.account_manager_ids[0]["id"]
							? Number(
									this.displayedPendingInvoices[index].account_manager_ids[0][
										"id"
									]
							  )
							: null,
						commentary: invoice.description,
						to_bill: 0,
						price: Number(invoice.currency_price_before_tax),
						quantity: Number(invoice.quantity),
						total_price: Number(invoice.currency_amount),
						tva_id: this.displayedPendingInvoices[index].tva_type_id,
						tva_name: this.displayedPendingInvoices[index].tva_name,
						tva_percentage: this.displayedPendingInvoices[index].tva_percentage,
						edit_state: false,
						sold_percentage: 0,
						prix_collab_text: null,
						is_order: 0,
					};
					console.log(formatedData);
					this.displayedPendingInvoices[index].items.push(formatedData);
					this.updateItemPrice(
						index,
						this.displayedPendingInvoices[index].items.length - 1
					);
					this.pendingItemsRefreshKey++;
					console.log(
						"Display Pending Invoice:",
						this.displayedPendingInvoices[index].items
					);
				})
				.catch((err) => {
					console.log("Error addInvoiceTemporaryOneItem:", err);
				});
		},

		getCustomer(index) {
			this.historicalInvoices[index][3] = true;
			// //console.log(this.$refs[`ft${index}`][0]);
			this.$http
				.get(
					this.apiUrl +
						"pending_invoices/customers/society/" +
						this.displayedPendingInvoices[index].society_id
				)
				.then((res) => {
					if (res.data.length > 0) {
						this.$http
							.get(
								this.apiUrl +
									"qb/action_select/get_contract_invoices/" +
									this.displayedPendingInvoices[index].contract_id +
									"/" +
									res.data[0].quickbooks_customer_id
							)
							.then((result) => {
								this.historicalInvoices[index][0] = result.data;
								this.historicalInvoices[index][2] = false;
								this.historicalInvoices[index][1] = false;
								this.invoiceRefreshKey = this.invoiceRefreshKey + 1;

								this.$refs[`ft${index}`][0].$props["list"] =
									this.historicalInvoices[index][0];
								this.$refs[`ft${index}`][0].$props["loader"] =
									this.historicalInvoices[index][1];
								this.$refs[`ft${index}`][0].$props["error"] =
									this.historicalInvoices[index][2];
							});
					} else {
						this.historicalInvoices[index][1] = false;
						this.$refs[`ft${index}`][0].$props["loader"] =
							this.historicalInvoices[index][1];
						this.invoiceRefreshKey = this.invoiceRefreshKey + 1;
					}
				})
				.catch((err) => {
					this.historicalInvoices[index][2] = true;
					this.historicalInvoices[index][1] = false;
					this.$refs[`ft${index}`][0].$props["loader"] =
						this.historicalInvoices[index][1];
					this.$refs[`ft${index}`][0].$props["error"] =
						this.historicalInvoices[index][2];
					this.invoiceRefreshKey = this.invoiceRefreshKey + 1;
				});
		},

		getAllTVA() {
			this.$http.get(this.apiUrl + "pending_invoices/tva/all").then((res) => {
				this.tvaList = res.data;
			});
		},

		getTVA(tva_id) {
			let filteredList = this.tvaList.filter((tva) => tva.id == tva_id);
			return filteredList.length > 0 ? filteredList[0].percentage : "0";
		},

		getTTCPrice(item) {
			return (
				item.total_price * (1 + parseFloat(this.getTVA(item.tva_id) / 100))
			);
		},

		isBilled(index) {
			if (this.displayedPendingInvoices[index].is_sent == 1) return "success";
			else return "primary";
		},
		isNotBilled(index) {
			if (this.displayedPendingInvoices[index].is_sent == 2) return "danger";
			else return "primary";
		},
		cancelInvoice(index) {
			this.displayedPendingInvoices[index].is_sent =
				this.displayedPendingInvoices[index].is_sent == 2 ? 0 : 2;
			// UPDATE PENDING INVOICE
			this.$http
				.get(
					this.apiUrl +
						"pending_invoices/invoices/update/status/" +
						this.displayedPendingInvoices[index].id +
						"/" +
						this.displayedPendingInvoices[index].is_sent
				)
				.then((result) => {
					// //console.log(result);
				})
				.catch((err) => {
					//console.log(err);
				});
		},
		acceptInvoice(index) {
			if (this.displayedPendingInvoices[index].total_ht == 0) {
				this.$vs.notify({
					title: "Echec",
					text: "Le prix de la facture est à zéro.",
				});
			} else if (this.displayedPendingInvoices[index].is_sent == 1) {
				this.$vs.notify({
					title: "Echec",
					text: "La facture a déjà été envoyée.",
				});
			} else {
				// POPUP VALIDATION
				this.invoiceToSend = index;
				this.showValidatePopup = true;
			}
		},

		acceptBilling() {
			this.acceptBillingLoad = true;

			// UPDATE PENDING INVOICE AND SEND
			this.$http
				.post(
					this.apiUrl + "qb/invoices/updateandsend",
					this.displayedPendingInvoices[this.invoiceToSend]
				)
				.then((result) => {
					// //console.log(result);
					this.acceptBillingLoad = false;
					this.displayedPendingInvoices[this.invoiceToSend].is_sent = 1;
					this.invoiceToSend = null;
					this.showValidatePopup = false;
				})
				.catch((err) => {
					this.acceptBillingLoad = false;
					if (err && err.length > 1) {
						if (err[0] == "ERROR") {
							this.$vs.notify({
								title: "Echec",
								text: "Une erreur s'est produite, veuillez contacter l'équipe technique.",
								color: "danger",
							});
						}
						if (err[0] == "UPDATE") {
							let notification_text = `Des prestations (${err[1].join(
								","
							)}) ne sont pas reliées au dashboard, veuillez contacter l'équipe technique.`;
							this.$vs.notify({
								title: "Echec",
								text: notification_text,
								color: "danger",
							});
						}
					} else if (err) {
						this.$vs.notify({
							title: "Echec",
							text: "Une erreur s'est produite, veuillez contacter l'équipe technique.",
							color: "danger",
						});
					}
				});
		},

		declineBilling() {
			this.invoiceToSend = null;
			this.showValidatePopup = false;
		},

		updateHTPrices(index) {
			let new_total_ht = 0;
			let new_total_ttc = 0;
			let new_total_ttc_test = 0;
			for (
				let i = 0;
				i < this.displayedPendingInvoices[index].items.length;
				i++
			) {
				new_total_ht += this.displayedPendingInvoices[index].items[i].to_bill
					? this.displayedPendingInvoices[index].items[i].total_price
					: 0;
				// let percentageNum = this.displayedPendingInvoices[index].items[i].sold_percentage ? ((this.displayedPendingInvoices[index].items[i].sold_percentage/100) * new_total_ht): 0;
				new_total_ttc += this.displayedPendingInvoices[index].items[i].to_bill
					? this.displayedPendingInvoices[index].items[i].ttc_total_price
					: 0;

				// if(new_total_ht > 0 && this.displayedPendingInvoices[index].items[i].to_bill) //console.log("updateHTPrices Loop: ", index, this.displayedPendingInvoices[index].items[i].ttc_total_price);
			}
			// console.log("a", new_total_ttc_test, new_total_ttc);

			this.displayedPendingInvoices[index].total_ht = new_total_ht;
			this.displayedPendingInvoices[index].total_ttc = new_total_ttc;
			// if(new_total_ht > 0) //console.log("updateHTPrices: ", index, new_total_ht, new_total_ttc);
		},

		updateItemPrice(index, itemIndex) {
			this.displayedPendingInvoices[index].items[itemIndex].price =
				typeof this.displayedPendingInvoices[index].items[itemIndex].price ==
					"string" &&
				this.displayedPendingInvoices[index].items[itemIndex].price.includes(
					","
				)
					? this.displayedPendingInvoices[index].items[itemIndex].price.replace(
							",",
							"."
					  )
					: this.displayedPendingInvoices[index].items[itemIndex].price;
			this.displayedPendingInvoices[index].items[itemIndex].total_price =
				parseFloat(
					(
						this.displayedPendingInvoices[index].items[itemIndex].price *
						this.displayedPendingInvoices[index].items[itemIndex].quantity
					).toFixed(2)
				);

			let newTVA = this.tvaList.find(
				(row) =>
					row.id == this.displayedPendingInvoices[index].items[itemIndex].tva_id
			);
			this.displayedPendingInvoices[index].items[itemIndex].tva_name = newTVA
				? newTVA.name
				: "";
			this.displayedPendingInvoices[index].items[itemIndex].tva_percentage =
				newTVA ? newTVA.percentage : 0;

			this.displayedPendingInvoices[index].items[itemIndex].ttc_total_price =
				parseFloat(
					(
						this.displayedPendingInvoices[index].items[itemIndex].total_price *
						(1 +
							this.displayedPendingInvoices[index].items[itemIndex]
								.tva_percentage /
								100)
					).toFixed(2)
				);
			this.updateHTPrices(index);
		},

		updateAllHTPrices() {
			for (let i = 0; i < this.displayedPendingInvoices.length; i++) {
				this.updateHTPrices(i);
			}
		},

		updateTVA(item) {
			return new Promise((resolve, reject) => {
				if (!item.id) resolve(false);
				let params = {
					id: item.id,
					tva_id: item.tva_id,
				};
				this.$http
					.post(this.apiUrl + "pending_invoices/tva/updateitem", params)
					.then((result) => {
						// //console.log("updateTVA", result.data);
						resolve(result.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},

		async updateItem(item) {
			await this.updateTVA(item);

			item.edit_state = false;
		},

		getAllInvoicesItems() {
			this.$http
				.get(this.apiUrl + "pending_invoices/item/all")
				.then((result) => {
					this.invoicesItems = result.data;
				})
				.catch((err) => {
					this.invoicesItems = [];
					//console.log(err);
				});
		},

		formatToFrenchDateString(date) {
			// //console.log("formatToFrenchDateString", date);
			if (date.split("/").length > 1) {
				// //console.log("formatToFrenchDateString if", date);
				return date;
			} else {
				let objDate = new Date(this.formatToInternationalDateString(date));
				objDate.setDate(objDate.getDate() + 1);
				// //console.log("formatToFrenchDateString else", objDate.toISOString().substring(0, 10).split("-").reverse().join("/"));
				return date
					? objDate
							.toISOString()
							.substring(0, 10)
							.split("-")
							.reverse()
							.join("/")
					: "";
			}
		},

		formatToInternationalDateString(date) {
			if (date.split("/").length > 1) {
				let strDate = date.split("/").reverse().join("-");
				return strDate;
			} else {
				return date;
			}
		},

		getCollaboratorAvatar(userId) {
			let foundAvatar = this.allCollaboratorsAvatar.find(
				(avatar) => avatar.id == userId
			);
			if (foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		getCollaboratorName(userId) {
			let foundCollaborator = this.allCollaborators.find(
				(collaborator) => collaborator.id == userId
			);
			if (foundCollaborator)
				return String(
					foundCollaborator.firstname + " " + foundCollaborator.lastname
				);
			else return " ";
		},

		getLastMonthFromToDate() {
			let today = new Date(Date.now());
			let year =
				today.getMonth() - 1 < 0
					? Number(today.getFullYear()) - 1
					: today.getFullYear();
			let month = today.getMonth() - 1 < 0 ? 11 : today.getMonth();
			// let day = today.getDate()
			this.dateFromFilter = new Date(year, month, 1).toISOString();
			this.dateToFilter = new Date(
				today.getFullYear(),
				today.getMonth(),
				0
			).toISOString();
		},

		displayPendingInvoices() {
			this.displayedPendingInvoices = [];
			this.displayedPendingInvoices = this.pending_invoices;
			for (let i = 0; i < this.displayedPendingInvoices.length; i++) {
				this.newItems.push({
					product_id: null,
					price: null,
					quantity: null,
					commentary: null,
				});
				this.historicalInvoices.push([[], true, false, false]);
			}
			this.updateAllHTPrices();
		},

		/**
		 * Return true if a filter has been set
		 * @return {Boolean} - Is filter set ?
		 */
		isFilterSet() {
			////console.log("isFilterSet BEGIN")
			if (
				this.contractNumberFilterOn ||
				this.dateFromFilterOn ||
				this.dateToFilterOn ||
				this.expertiseFilterOn ||
				this.providerFilterOn ||
				this.societyFilterOn ||
				this.recurrenceFilterOn
			)
				return true;
			return false;
		},

		/**
		 * Return list of filtered pending_invoices A CHANGER
		 * @param {String} contractNumberFilter - Contract number filter search value
		 * @param {String} societyFilter - String to match in society name
		 * @param {String} recurrenceFilter - Recurrence's Frequency number filter search value
		 * @return {List} - Purchases' list filtered
		 */
		filterPurchases(pending_invoices) {
			////console.log("filterProviders BEGIN")
			let purchasesList = [];

			let searchKeyList = {};
			this.dateFromFilterOn
				? (searchKeyList["dateFromFilter"] = new Date(
						this.dateFromFilter.split("/").reverse().join("-")
				  ))
				: false;
			this.dateToFilterOn
				? (searchKeyList["dateToFilter"] = new Date(
						this.dateToFilter.split("/").reverse().join("-")
				  ))
				: false;
			this.expertiseFilterOn
				? (searchKeyList["expertiseFilter"] = this.expertiseFilter)
				: false;
			this.societyFilterOn
				? (searchKeyList["societyFilter"] = this.societyFilter)
				: false;
			this.contractNumberFilterOn
				? (searchKeyList["contractNumberFilter"] =
						this.contractNumberFilter.toString())
				: false;
			this.providerFilterOn
				? (searchKeyList["providerFilter"] = this.providerFilter)
				: false;
			this.recurrenceFilterOn
				? (searchKeyList["recurrenceFilter"] = this.recurrenceFilter)
				: false;

			for (let purchaseToFilter of pending_invoices) {
				let purchaseSearchKeyList = {};
				let purchaseDate = purchaseToFilter.recurrence_date
					? purchaseToFilter.recurrence_date
					: purchaseToFilter.bought_at;
				let re = new RegExp("([T|Z])", "g");
				purchaseDate = purchaseDate ? purchaseDate.replace(re, " ") : null;
				purchaseDate = purchaseDate ? new Date(purchaseDate) : null;
				this.dateFromFilterOn
					? (purchaseSearchKeyList["dateFromFilter"] = purchaseDate)
					: false;
				this.dateToFilterOn
					? (purchaseSearchKeyList["dateToFilter"] = purchaseDate)
					: false;
				this.expertiseFilterOn
					? (purchaseSearchKeyList["expertiseFilter"] =
							purchaseToFilter.service_id)
					: false;
				this.societyFilterOn
					? (purchaseSearchKeyList["societyFilter"] =
							purchaseToFilter.contract_society_id)
					: false;
				this.contractNumberFilterOn
					? (purchaseSearchKeyList["contractNumberFilter"] =
							purchaseToFilter.contract_id.toString())
					: false;
				this.providerFilterOn
					? (purchaseSearchKeyList["providerFilter"] =
							purchaseToFilter.users_id)
					: false;
				this.recurrenceFilterOn
					? (purchaseSearchKeyList["recurrenceFilter"] =
							purchaseToFilter.recurrence)
					: false;

				let check = true;

				for (let key in searchKeyList) {
					if (typeof searchKeyList[key] == "string") {
						if (typeof purchaseSearchKeyList[key] == "string") {
							if (!purchaseSearchKeyList[key].includes(searchKeyList[key])) {
								check = false;
								break;
							}
						} else if (typeof purchaseSearchKeyList[key] == "object") {
							let checkLoop = false;
							for (let value of purchaseSearchKeyList[key]) {
								let service_name = this.getServiceIdToName(value).toLowerCase();
								if (service_name.includes(searchKeyList[key])) {
									checkLoop = true;
								}
							}
							if (!checkLoop) {
								check = checkLoop;
								break;
							}
						}
					} else if (searchKeyList[key] instanceof Date) {
						if (key == "dateFromFilter") {
							check = searchKeyList[key] <= purchaseSearchKeyList[key];
						}
						if (key == "dateToFilter") {
							check = searchKeyList[key] >= purchaseSearchKeyList[key];
						}
						if (!check) break;
					} else {
						if (purchaseSearchKeyList[key] != searchKeyList[key] - 1) {
							check = false;
							break;
						}
					}
				}

				if (check) purchasesList.push(purchaseToFilter);
			}
			return purchasesList;
		},

		searchAndDisplay() {
			this.displayedPendingInvoices = this.filterPurchases(
				this.displayedPurchasesFull
			);
		},

		/**
		 * Add prefix to url using the mixin
		 */
		getPrefixedUrl(url) {
			return this.urlPrefixAdder(url);
		},

		formatDate(date_input) {
			if (date_input && date_input.length > 10) {
				return date_input.substring(0, 10);
			} else {
				return date_input;
			}
		},
		getAllServices() {
			this.$store.dispatch("getAllServices");
		},
		/**
		 * Get all societies in store states
		 */
		getAllSocieties() {
			this.$store.dispatch("getAllSocieties");
		},
		getAllProviders() {
			this.$store.dispatch("getAllProviders");
		},

		getAllProducts() {
			this.$store.dispatch("getAllProducts");
		},

		getAllProductsCategories() {
			this.$store.dispatch("getAllProductsCategories");
		},

		displayContractPopup(contractId) {
			// //console.log("displayContractPopup", contractId)
			this.selectedContract = contractId;
			this.$emit("contract-info-popup", contractId);
		},

		displaySocietyPopup(societyId) {
			// //console.log("displayContractPopup", contractId)
			this.selectedSociety = societyId;
			this.$emit("show-society-popup", societyId);
		},

		// NEW GOOGLE ADS METHODS - BATCHED APPROACH

		/**
		 * Check if Google Ads are loading for a specific society
		 */
		isGoogleAdsLoading(societyId) {
			return this.googleAdsLoadingStates[societyId] || false;
		},

		/**
		 * Get Google Ads data for a specific society
		 */
		getGoogleAdsForSociety(societyId) {
			return this.googleAdsData[societyId] || [];
		},

		/**
		 * Fetch Google ads for all societies using batched approach (batch size = 3)
		 */
		async fetchGoogleAds() {
			// Get unique society IDs
			const societyIds = [
				...new Set(
					this.$props.pending_invoices.map((invoice) => invoice.society_id)
				),
			];

			// Get period from first invoice
			const period = moment(
				this.$props.pending_invoices[0].invoice_date
			).format("MM/YYYY");

			// Initialize loading states and data for all societies
			societyIds.forEach((societyId) => {
				this.$set(this.googleAdsLoadingStates, societyId, false);
				this.$set(this.googleAdsData, societyId, []);
			});

			// Process societies in batches of 3
			const batchSize = 3;
			for (let i = 0; i < societyIds.length; i += batchSize) {
				const batch = societyIds.slice(i, i + batchSize);

				// Start all requests in current batch
				const promises = batch.map(async (societyId) => {
					// Set loading state for this society
					this.$set(this.googleAdsLoadingStates, societyId, true);

					try {
						// Fetch data for single society
						const adsData = await Society.fetchGoogleAds([societyId], period);

						// Store the result
						this.$set(this.googleAdsData, societyId, adsData);
					} catch (error) {
						console.error(
							`Error fetching Google Ads for society ${societyId}:`,
							error
						);
					} finally {
						// Always clear loading state
						this.$set(this.googleAdsLoadingStates, societyId, false);
					}
				});

				// Wait for current batch to complete before starting next
				await Promise.all(promises);

				// Trigger reactivity update
				this.googleAdsKey++;

				// Small delay between batches to avoid overwhelming the API
				if (i + batchSize < societyIds.length) {
					await new Promise((resolve) => setTimeout(resolve, 300)); // 300ms delay
				}
			}
		},
	},
};
</script>
  
<style>
#invoice_table > .con-tablex.vs-table--content {
	max-height: 100%;
}
.thead-service > div > div > table > thead > tr {
	background-color: #0c293d;
	color: white;
}
div.content-tr-expand {
	padding: 0;
}
.center {
	justify-content: center;
}
.myBtn {
	background-color: transparent !important;
}
.myBtn:hover {
	box-shadow: none !important;
	background-color: orange !important;
}
.myBtnPrimary {
	color: rgba(var(--vs-primary), 1) !important;
	background-color: transparent !important;
}
.myBtnPrimary:hover {
	box-shadow: none !important;
	background-color: rgba(var(--vs-primary), 1) !important;
}

.hvr-underline-out {
	color: black;
}
.hvr-underline:hover {
	color: aqua;
	text-decoration: underline;
	cursor: pointer;
}
.chips-status > div > div > table > tr > td:nth-child(3) > span {
	display: flex;
	justify-content: center;
}

th > div {
	white-space: normal !important;
}

th > div > span {
	text-transform: uppercase;
}

.th-sticky {
	position: sticky;
	top: 0;
	background-color: inherit;
}

th.td-check {
	position: sticky;
	top: 0;
	background-color: inherit;
	pointer-events: auto;
}
#expandAll {
	border: none;
	pointer-events: auto;
	cursor: pointer;
}
.extrue {
	padding-top: 20px;
	padding-right: 10px;
	background: none;
	transform: rotate(-90deg);
}

.exfalse {
	padding-left: 5px;
	background: none;
	transform: rotate(0deg);
}

.expand-row td {
	background-color: #ffffffff;
	padding: 20px !important;
}

.expand-icon-wrapper:hover {
	background-color: rgba(0, 0, 0, 0.05);
	border-radius: 4px;
}

.content-tr-expand > div > div > div > div > div > table > thead > tr {
	background: #0c293d;
}
.content-tr-expand
	> div
	> div
	> div
	> div
	> div
	> table
	> thead
	> tr
	> th
	> div {
	color: white;
}
.max-width-control > div > div {
	max-height: calc(100vh - 250px);
}
.content-tr-expand > div > div > div > div > div > table > thead > tr {
	background: #0c293d;
}
.content-tr-expand
	> div
	> div
	> div
	> div
	> div
	> table
	> thead
	> tr
	> th
	> div {
	color: white;
}

.th-sticky {
	position: sticky;
	top: 0;
	background-color: inherit;
}
</style>